import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { CdrDateInterval, generateIntervalOptions } from "../reports/config/date-interval";
import { UserService } from "@onsip/common/services/api/resources/user/user.service";

@Component({
  selector: "onsip-pbx-overview",
  templateUrl: "./pbx-overview.component.html",
  styleUrls: ["./pbx-overview.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PbxOverviewComponent implements OnInit, OnDestroy {
  @HostBinding("class.onsip-grid-content")
  @HostBinding("class.onsip-admin-host-grid")
  _dontUse = true;

  intervalOptions = generateIntervalOptions();

  intervalForm = new FormControl();

  dateStart!: string;
  dateEnd!: string;

  isAccountAdmin$ = this.userService.selfUserIsAccountAdmin$;

  private unsubscriber = new Subscription();

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.unsubscriber.add(
      this.intervalForm.valueChanges.subscribe((value: CdrDateInterval) => {
        this.dateStart = value.dateStart.split("T")[0];
        this.dateEnd = value.dateEnd.split("T")[0];
      })
    );
    this.intervalOptions = this.intervalOptions.slice(1);
    this.intervalForm.setValue(this.intervalOptions[3]);
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }
}
